var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.586 263.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f15a24",
    d: "m23.573 233.592 22.414 22.374-.002-.001L0 257.56zM254.58 137.09c-8.543 66.613-69.475 113.676-136.077 105.123C51.889 233.668 4.826 172.737 13.37 106.129 21.919 39.518 82.838-7.55 149.457 1.004c66.61 8.541 113.684 69.477 105.124 136.083"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M164.982 87.041c7.99 8.494.104 28.577.104 28.577s-7.794 28.394-52.421 65.213l-8.33-8.176 56.65-57.9 1.095-1.477c1.507-2.456 2.755-26.402 2.902-26.237"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "M164.982 87.041c7.99 8.494.104 28.577.104 28.577s-7.794 28.394-52.421 65.213l-8.33-8.176 56.65-57.9 1.095-1.477c1.507-2.456 2.755-26.402 2.902-26.237z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m92.1 160.618 72.763-73.786c3.693 4.386 4.479 9.11 3.407 15.843-.722 4.662-8.775 13.98-8.775 13.98l-55.16 56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.201,
    d: "m92.1 160.618 72.763-73.786c3.693 4.386 4.479 9.11 3.407 15.843-.722 4.662-8.775 13.98-8.775 13.98l-55.16 56"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff931e",
    d: "M164.982 87.093 92.099 160.62l.147-.143-.027.01-18.083-17.817c37.708-46.905 62.089-55.65 62.089-55.65s15.872-6.196 27.195-1.388c.87.466 1.248.734 1.56 1.463"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "M164.982 87.093 92.099 160.62l.147-.143-.027.01-18.083-17.817c37.708-46.905 62.089-55.65 62.089-55.65s15.872-6.196 27.195-1.388c.87.466 1.248.734 1.56 1.463z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M112.665 180.83c-17.388 14.32-39.641 36.815-69.889 52.505l6.728 28.763-28.516-28.087 71.11-73.393"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "M112.665 180.83c-17.388 14.32-39.641 36.815-69.889 52.505l6.728 28.763-28.516-28.087 71.11-73.393"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f15a24",
    d: "m51.478 169.345 22.754-26.752.393.317h-.002l17.665 17.596z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "m51.478 169.345 22.754-26.752.393.317h-.002l17.665 17.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M158.024 65.756c-1.733 15.64 9.528 29.72 25.168 31.465 15.628 1.736 29.721-9.533 31.465-25.168 1.738-15.635-9.54-29.73-25.174-31.469-15.642-1.727-29.724 9.528-31.459 25.172"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "M158.024 65.756c-1.733 15.64 9.528 29.72 25.168 31.465 15.628 1.736 29.721-9.533 31.465-25.168 1.738-15.635-9.54-29.73-25.174-31.469-15.642-1.727-29.724 9.528-31.459 25.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M210.565 84.648c5.256-7.68 4.984-19.167 3.929-22.57-1.295-4.168-4.191-10.946-9.243-14.468l-26.714 24.606s20.53 22.058 21.065 22.132c.222.025 6.17-2.699 10.963-9.7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "M210.565 84.648c5.256-7.68 4.984-19.167 3.929-22.57-1.295-4.168-4.191-10.946-9.243-14.468l-26.714 24.606s20.53 22.058 21.065 22.132c.222.025 6.17-2.699 10.963-9.7zm-5.39-19.276s2.569 6.308-.69 11.215z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m104.964 172.666-29.482 5.246 17.796-18.49"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918,
    d: "m104.964 172.666-29.482 5.246 17.796-18.49m-17.97-16.383 37.48 35.274"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostman);
export default __webpack_public_path__ + "static/media/postman.8faefdfeef74af5fc06c083add096125.svg";
export { ForwardRef as ReactComponent };